/**
 * Created by jonas on 2022-06-15.
 */
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {AvalancheWinInfo} from "../server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaSymbol, KitchenDramaSushiManiaSymbolStates} from "../reels/KitchenDramaSushiManiaSymbol";
import {GSAPUtils} from "../utils/GSAPUtils";
import {gsap} from "gsap";
import {StateMatrix, StateMatrixCoordinate} from "../utils/StateMatrix";
import {KitchenDramaSushiManiaReelsView} from "../reels/KitchenDramaSushiManiaReelsView";
import {KitchenDramaSushiManiaGameMode} from "../server/KitchenDramaSushiManiaGameMode";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";

export class TransformSushiWildsPresentation implements SimplePresentation {
    name:string = "TransformSushiWildsPresentation";
    private roundIndex:number;

    constructor(index:number) {
        this.roundIndex = index;
    }

    shouldRun():boolean {
        return KitchenDramaSushiMania.model.data.mode == KitchenDramaSushiManiaGameMode.WILD_SUSHI;
    }

    start(controller:SimplePresentationRunnerController):void {
        const symbolsNamesToTransform = KitchenDramaSushiMania.model.gameData.avalancheWinInfo[this.roundIndex].wildSymbols;
        const reelMatrix = new StateMatrix<string>(KitchenDramaSushiMania.model.gameData.reels[this.roundIndex]);
        const wildTransformPositions:StateMatrixCoordinate[] = reelMatrix.getAllCoordinatesForValues(symbolsNamesToTransform);

        if (wildTransformPositions.length <= 0){
            controller.finish();
            return;
        }


        const transformAnimations = []
        for (let transformPos of wildTransformPositions){

            const oldSym = KitchenDramaSushiMania.reelView.getVisibleSymbolDataAt(transformPos.column, transformPos.row);
            if (oldSym.name == "W3"){
                continue;
            }

            const swapData = KitchenDramaSushiMania.reelView.transformSymbolAt(transformPos.column, transformPos.row, "W3");
            (<KitchenDramaSushiManiaSymbol>swapData.newSymbol.positionable).transformHide(0);

            const transformTl = gsap.timeline();
            transformTl.add((<KitchenDramaSushiManiaSymbol>swapData.oldSymbol.positionable).transformSushiHide());
            transformTl.add((<KitchenDramaSushiManiaSymbol>swapData.newSymbol.positionable).transformToSushiWild());

            transformTl.add(()=>{
                KitchenDramaSushiMania.reelView.removeSymbol(swapData.oldSymbol);
            });

            transformAnimations.push(transformTl);

        }

        if (transformAnimations.length > 0){
            const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
            tl.add(GSAPUtils.createTimelineFromArray(transformAnimations, "<"));
            tl.add(()=>{
                KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.TURN_INTO_WILD_SUSHI);
            }, "<+0.25");
        }
        else  {
            controller.finish();
        }



    }
}